import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { FormProvider, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime, request, toast, BASE_URL } from '../../../../../utils';
import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { OpdPatientLedgerPdf } from '../../../../Print/options/Hospital/HMS';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';


export const OpdPatientLedger = () => {
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [filteredPatientList, setFilteredPatientList] = useState([]);
  const [uhidInput, setUhidInput] = useState('');
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [openPrint, setOpenPrint] = useState(false);
  const doctorIDRef = useRef();
  const [loading, setLoading] = useState(false);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });

  const PATIENT_TABLE_HEADER = [
    { header: 'UHID', accessor: 'uhid' },
    { header: 'OP No', accessor: 'op_no' },
    { header: 'Created At', accessor: 'reg_date' },
    { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
    { header: 'Mobile No', accessor: 'address.mobile' },
    { header: 'Doctor', accessor: 'consultant.name' },
    { header: 'Address', accessor: 'address.address' }
  ];

  const { handleSubmit, watch, setValue, reset } = methods;

  const searchPatientHandler = async (uhid = null) => {
    if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
    setLoading(true);
    if (!uhid) setSearchPatientRegisterationDialog(true);
    const response = await request('/patient-registeration-search', { method: 'GET', query: { uhid } });
    if (response?.success) {
      if (uhid) {
        const {
          data: [patientData]
        } = response;
        setValue('visit', patientData.visit_no);
        setValue('op', patientData.op_no);
        setValue('patient_name', `${patientData.first_name} ${patientData.last_name}`);
        setValue('patient_suffix', patientData.name_suffix);
        setValue('opd_type', patientData.opd_type?.type);
        setValue('ref_type', patientData.ref_by?.referral_name);
        setValue('application_no', patientData.app_no_date);
        setValue('doctor', patientData.consultant?.name);
        doctorIDRef.current = patientData.consultant?._id;
        setValue('department', patientData.department?.department);
        setValue('sponsor', patientData.sponsor?.name);
        setValue('remarks', patientData.remarks);
        setValue('queue_no', patientData.app_no_date);
        setValue('card_no', patientData.chq_card_no);
        setValue('vertical', patientData.vertical?.verticalname);
      } else {
        const allPatients = response?.data || [];
        allPatients.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPatientDetailList(allPatients);
        setFilteredPatientList(allPatients);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }

    setLoading(false);
  };

  const handleUhidSearch = () => {
    const lowercasedInput = uhidInput.toLowerCase();
    const filtered = patientDetailList.filter(
      (item) =>
        item.uhid.toString().toLowerCase().includes(lowercasedInput) ||
        item.first_name.toLowerCase().includes(lowercasedInput) ||
        (item.address.mobile && item.address.mobile.toLowerCase().includes(lowercasedInput))
    );
    setFilteredPatientList(filtered);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(`${BASE_URL}/print/hospital/outpatient-management/opd-patient-ledger?refId=${JSON.stringify({ sponsor: watch('sponsor'), from_date: watch('from_date'), to_date: watch('to_date') })}`)
    //  console.log("response data", response);
    if (response.data.success) {
      const filteredData = response?.data?.data || [];
      if (filteredData.length > 0) {
        console.log("Conditional Data", filteredData);

        const fileName = `Opd_Patient_Ledger_${watch('from_date')}_to_${watch('to_date')}`;

        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          'Bill Date': formatDate(item?.opd?.date),
          'Bill No.': item?.opd?.op_no,
          'Doctor Name': item?.opd?.consultant?.name,
          'Service': "OPD",
          'Net Amount': item?.opd?.total

        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Opd Patient Ledger
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('department')}
                  id={`${lastPathSegment}Print`}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ uhid: watch('uhid'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    )} >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  disabled={!watch('department')}
                  id={`${lastPathSegment}Print`}
                  onClick={handleExcelReport} >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Uhid</Typography>
                    <TextField sx={{ flex: 0.7 }} name="uhid" />
                    <Button
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={() => searchPatientHandler()}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>

                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <OpdPatientLedgerPdf />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        open={searchPatientRegisterationDialog}
        onClose={() => setSearchPatientRegisterationDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Registered Patient
          </Typography>
          <IconButton onClick={() => setSearchPatientRegisterationDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={uhidInput}
            onChange={(e) => {
              setUhidInput(e.target.value);
              handleUhidSearch();
            }}
          />
        </Stack>
        {filteredPatientList.length > 0 ? (
          <Table
            sx={{ mt: 0.5 }}
            columns={PATIENT_TABLE_HEADER}
            data={filteredPatientList || []}
            onRowClick={(row) => {
              setValue('uhid', row.uhid);
              setValue('visit', row.visit_no);
              setValue('op', row.op_no);
              setValue('patient_name', `${row.first_name} ${row.last_name}`);
              setValue('patient_suffix', row.name_suffix);
              setValue('opd_type', row.opd_type?.type);
              setValue('ref_type', row.ref_by?.referral_name);
              setValue('application_no', row.app_no_date);
              setValue('doctor', row.consultant?.name);
              doctorIDRef.current = row.consultant?._id;
              setValue('department', row.department?.department);
              setValue('sponsor', row.sponsor?.name);
              setValue('remarks', row.remarks);
              setValue('queue_no', row.app_no_date);
              setValue('card_no', row.chq_card_no);
              setValue('vertical', row.vertical?.verticalname);
              setSearchPatientRegisterationDialog(false);
            }}
          />
        ) : (
          <p style={{ textAlign: 'center', fontSize: '24px', color: 'red' }}>No Data Found</p>
        )}
      </Dialog>
    </>
  );
};
